// extracted by mini-css-extract-plugin
module.exports = {"container":"card-module--container--KibZA","color":"card-module--color--2rMGS"};